// extracted by mini-css-extract-plugin
export default {"default-column":"TableCell_default-column__IPT+d","undo-icon":"TableCell_undo-icon__cDoZs"};